module.exports = __webpack_public_path__ + "img/J1L404.448a4ef9.svg";